import Effects from './Effects.js';
import Tone from 'tone';
const SIZE=512*2;
class Oscilloscope extends Effects.Effect {
    constructor(sequencerEngine) {
        super('Oscilloscope', () => new Tone.Analyser({type: 'waveform', size: SIZE}), sequencerEngine); 

        this.size = SIZE;
        this.newOutlet("Waveform Data");
        this.newInlet("Start", () => this.onStart());
    }

    dispose() {
        if (this.interval) {
            clearInterval(this.interval);
        }
        super.dispose();
    }
    onStart() {
        this.interval = setInterval(() => {
            this.sendMessage("Waveform Data", this.getValue());
        }, 64);
    }

    getValue() {
        return this.effectNode.getValue();
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        let effect = new Oscilloscope(sequencerEngine);
        return effect;
    }
}

export default Oscilloscope;
